<template>
  <div class="checkout-bill-payment-page">
    <div class="bill-payment-loading-container" v-if="billPaymentIsLoading">
      <Loading />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import Button from '@/components/Button'
import Loading from '@/components/Loading'
import { DOMAIN } from '@/lib/api'
import { generatePdfViewerUrl } from '@/lib/services'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

const { mapFields: mapPaymentFields } = createHelpers({
  getterType: 'getPaymentFields',
  mutationType: 'updatePaymentFields',
})

export default {
  name: 'PaymentBillPayment',
  props: ['application_id'],
  components: {
    Button,
    Loading,
  },
  watch: {
    applicationInformation: {
      handler() {
        this.payViaBillPayment(this.application_id)
      },
      deep: true,
    },
    billPaymentData(data) {
      const billpaymentUrl = `${DOMAIN}${data.billPaymentUrl}`

      window.open(generatePdfViewerUrl(billpaymentUrl), '_blank')

      this.$router.push(`/payment/bill-payment/success/${this.application_id}`)
    },
    billPaymentIsError(isError) {
      if (isError) {
        this.$swal({
          type: 'error',
          title:
            'ขออภัยระบบเกิดความผิดพลาดในการสร้าง Bill payment กรุณาติดต่อมาที่เบอร์โทรศัพท์ 1231 ต่อ 2951',
          allowOutsideClick: false,
        }).then(() => {
          const familyId = _.get(this.applicationInformation, 'familyQuotation.familyId', null)

          if (familyId) {
            return this.$router.push(`/insurance_family/${familyId}`)
          }

          return this.$router.push('/home')
        })
      }
    },
  },
  mounted() {
    this.getApplicationInformation(this.application_id)
  },
  computed: {
    ...mapApplicationFields({
      applicationInformation: 'data.applicationInformation',
    }),
    ...mapPaymentFields({
      billPaymentData: 'billPayment.data',
      billPaymentIsLoading: 'billPayment.isLoading',
      billPaymentIsError: 'billPayment.isError',
    }),
  },
  methods: {
    ...mapActions(['getApplicationInformation', 'payViaBillPayment']),
  },
}
</script>

<style lang="scss">
.checkout-bill-payment-page {
  padding-top: 48px;

  .checkout-bill-payment-container {
    margin: 0 auto;
    padding: 32px;
    width: 90%;

    .bill-payment-img-container {
      margin-bottom: 24px;

      .bill-payment-img {
        width: 100%;
      }
    }

    .send-email-btn-container {
      text-align: right;

      .mail-icon {
        margin-right: 8px;
      }
    }
  }

  .bill-payment-error-container {
    text-align: center;
  }
}
</style>
